import { useContext, useState } from 'react';
import ContactPersonImg from '../../assets/Contact person.png';
import { DataProvider } from '../../store/ContextProvider';

export const RaiseTicket = () => {
    const { RaiseTicket } = useContext(DataProvider)
    const [formData, setFormData] = useState({ subject: "", message: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const isFormValid = () => {
        const subjectCharCount = formData.subject.trim().length;
        const messageCharCount = formData.message.trim().length;
        return subjectCharCount >= 3 && messageCharCount >= 10;
    };


    const handleRaiseTicket = (e) => {
        e.preventDefault();
        if (isFormValid()) {
            RaiseTicket(formData);
            setFormData({ subject: "", message: "" });
        }
    };
    return (
        <div className="py-6 min-h-[65vh] bg-[#F8F8F8] flex justify-center items-center flex-wrap sm:flex-nowrap">

            {/* Left Side - Form */}
            <div className="w-full md:w-1/2">
                <h2 className="text-lg font-semibold my-2">
                    Need help with your Job or Issue?
                </h2>
                <p className="text-gray-600 mb-6 text-sm">
                    Fill in this quick form and our suport team will get back to you as soon as possible.
                </p>

                <form className='mt-8'>
                    {/* Subject */}
                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Subject <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter your subject (min 10 letters)"
                                className="w-full rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                name="subject"
                                value={formData?.subject}
                                onChange={handleChange}
                            />
                            {/* <p className="text-xs text-gray-500 mt-1">
                                Character count : {formData.subject.trim().length} / 10
                            </p> */}
                        </div>
                        {/* Describe Issue */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Describe Your Issue <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                rows="4"
                                placeholder="Write details about your issue here... (max 20 characters)"
                                className="w-full rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                name="message"
                                value={formData?.message}
                                onChange={handleChange}
                            ></textarea>
                            {/* <p className="text-xs text-gray-500 mt-1">
                                Character count : {formData.message.trim().length} / 20
                            </p> */}

                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            onClick={handleRaiseTicket}
                            disabled={!isFormValid()}
                            className={`px-5 py-2 rounded-lg transition-colors duration-200 w-full sm:w-auto 
                                ${isFormValid()
                                ? "bg-primary-300 hover:bg-blue-600 text-white"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                        >
                            Submit Ticket
                        </button>
                    </div>
                </form>
            </div>

            {/* Right Side - Illustration */}
            <div className="w-full p-3 flex justify-center items-center">
                <img
                    src={ContactPersonImg}
                    alt="Assistance Illustration"
                    className="h-[350px] md:h-[400px] lg:h-[450px]"
                />
            </div>

        </div>
    );
};
